import React from "react";
import { Link } from "react-router-dom";

export default function Pixel404() {
  return (
    <div style={{
      color: "#fff",
      height: "60vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "'VT323', monospace",
      textAlign: "center",
      padding: "0 20px"
    }}>
      {/* Big 404 with pixelated shadow */}
      <h1 style={{
        fontSize: "8rem",
        position: "relative",
        color: "#546842",
        textShadow: `
          4px 4px #88a66f,
          8px 8px #a6c48d
        `
      }}>404</h1>

      {/* Message */}
      <p style={{
        fontSize: "2rem",
        margin: "20px 0",
        color: "#fff"
      }}>
        Oops! Page not found.
      </p>

      {/* Retro button */}
      <Link to="/" className="header-link"
      onMouseEnter={e => e.currentTarget.style.transform = "translate(2px, 2px)"}
      onMouseLeave={e => e.currentTarget.style.transform = "translate(0, 0)"}
      >
        Go Home
      </Link>
    </div>
  );
}
